import "./fonts.css2.js";
const t = "https://static.parastorage.com/services/fonts-data/dist/fonts.bjyc89sn7hpxql3hj1f0.css";
export {
  t as default
};
//# sourceMappingURL=fonts.css.js.map
